import FilterPage from '.'

export default FilterPage
